import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  withStripe?: boolean;
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  className = ''
}: SectionHeadingProps) {
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-194">
      <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D1A1A] mb-3" data-id="element-195">
        {title}
      </h2>
      {subtitle && <p className="font-body text-[#6B1D4A] text-lg max-w-2xl mx-auto mb-6" data-id="element-196">
          {subtitle}
        </p>}
    </div>;
}